import React, { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDeviceType } from "hooks";
import { theme } from "constants/theme";
import { Navbar } from "components/navbar/index";
import { NavId } from "types/navigation";
import back from "assets/images/back-icon.png";
import greenBack from "assets/images/green-back-icon.png";
import { Modal } from "components/modal";
import { addBlog, getBlogBySlug, updateBlog } from "services/blogService";
import { CustomHeadline } from "components/ui";
import ArticleForm from "../ArticleForm/ArticleForm";
import { Blog } from "types/blog";
import moment from "moment";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { PreviewArticle } from "../preview-article/preview-article";

interface EditArticlePageProps {
  handleClose: (sectionId: string, sectionNumber: number) => void;
}

export const EditArticle: React.FC<EditArticlePageProps> = ({
  handleClose,
}) => {
  const [translate, setTranslate] = useState(0);
  const [activeSection, setActiveSection] = useState<number>(0);
  const [isHovered, setIsHovered] = useState(false);
  const { device } = useDeviceType();
  const isDesktop = device === "desktop";
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const [id, setId] = useState<string>();
  const [singleBlog, setSingleBlog] = useState<Blog | any>();

  const [previewBlog, setPreviewBlog] = useState(false);
  const [previewBlogData, setPreviewBlogData] = useState<Blog | any>();

  const defaultImages =
    id ===
    (process.env.REACT_APP_BLOG_DEFAULT_IMAGE_TITLE ||
      "mindscriber-default-images");

  const [checkingAuth, setCheckingAuth] = useState(true);
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        navigate("/admin");
      } else {
        setCheckingAuth(false);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (searchParams) {
      const idNumber = searchParams.get("id");
      idNumber && setId(idNumber);
    }
  }, [searchParams]);

  useEffect(() => {
    if (id) {
      (async () => {
        await getBlogBySlug(id)
          .then((res) => {
            setSingleBlog({
              ...res,
              date:
                res.date === "Invalid date"
                  ? moment(new Date()).format("YYYY-MM-DD")
                  : moment(res.date).format("YYYY-MM-DD"),
            });

            setPreviewBlogData({
              ...res,
              date:
                res.date === "Invalid date"
                  ? moment(new Date()).format("YYYY-MM-DD")
                  : moment(res.date).format("YYYY-MM-DD"),
            });
          })
          .catch((err) => {
            if (defaultImages) {
              if (err.message === "No article with this slug") {
                setSingleBlog({
                  title:
                    process.env.REACT_APP_BLOG_DEFAULT_IMAGE_TITLE ||
                    "mindscriber-default-images",
                  slug:
                    process.env.REACT_APP_BLOG_DEFAULT_IMAGE_TITLE ||
                    "mindscriber-default-images",
                  status: "default-image",
                  description: "",
                  customEditor: {},
                  bulletPoints: [],
                  desktopPreviewImageUrl: "",
                  desktopInnerImageUrl: "",
                  mobilePreviewImageUrl: "",
                  mobileInnerImageUrl: "",
                  date: moment(new Date()).format("YYYY-MM-DD"),
                });
                setPreviewBlogData({
                  title:
                    process.env.REACT_APP_BLOG_DEFAULT_IMAGE_TITLE ||
                    "mindscriber-default-images",
                  slug:
                    process.env.REACT_APP_BLOG_DEFAULT_IMAGE_TITLE ||
                    "mindscriber-default-images",
                  status: "default-image",
                  description: "",
                  customEditor: {},
                  bulletPoints: [],
                  desktopPreviewImageUrl: "",
                  desktopInnerImageUrl: "",
                  mobilePreviewImageUrl: "",
                  mobileInnerImageUrl: "",
                  date: moment(new Date()).format("YYYY-MM-DD"),
                });
              }
            }
            console.log("Error fetching blog:", err.message);
          });
      })();
    }
  }, [id]);

  const navigateToTop = useCallback(() => {
    if (device === "desktop") {
      document
        .getElementById(NavId.Section4)
        ?.scrollIntoView({ behavior: "smooth" });
      return;
    }
    setTranslate(0);
    setActiveSection(0);
  }, [device]);

  const resetvalue = () => {
    setSingleBlog(null);
    setPreviewBlogData(null);
    localStorage.removeItem("editorContent");
  };

  const handleSubmit = async (blog: Blog) => {
    if (!blog.id) {
      if (defaultImages) {
        await addBlog(blog)
          .then((res) => {
            navigate(
              defaultImages
                ? "/admin-article"
                : `/admin-article?status=${blog.status}`
            );
            resetvalue();
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.error("Missing blog ID");
        return;
      }
    } else {
      await updateBlog(blog.id, blog)
        .then((res) => {
          navigate(
            defaultImages
              ? "/admin-article"
              : `/admin-article?status=${blog.status}`
          );
          resetvalue();
          setId("");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  console.log("singleBlog====>", singleBlog);

  return (
    <>
      {previewBlog && previewBlogData ? (
        <PreviewArticle
          singleBlog={{
            ...previewBlogData,
          }}
          setSingleBlog={setSingleBlog}
          setPreviewBlog={setPreviewBlog}
        />
      ) : (
        <div className={styles.editArticle}>
          <Navbar
            activeSection={activeSection}
            navigateToTop={navigateToTop}
            theme="black"
            logoVariant="noLogoText"
            blur
          />
          <Modal
            setTranslate={setTranslate}
            setActiveSection={setActiveSection}
          />
          <div className={styles.container}>
            <img
              src={isHovered ? greenBack : back}
              alt="img"
              className={styles.closeButton}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => {
                navigate(
                  defaultImages
                    ? "/admin-article"
                    : `/admin-article?status=${singleBlog?.status}`
                );
                resetvalue();
              }}
            />

            <div className={styles.content}>
              <CustomHeadline
                size={isDesktop ? 55 : 24}
                text="Edit Article"
                color={theme.colors.neutral[20]}
                styles={{
                  lineHeight: `${isDesktop ? 52 : 26}px`,
                  marginBottom: "30px",
                }}
              />
              {singleBlog && (
                <ArticleForm
                  defaultImages={defaultImages}
                  existingBlog={singleBlog}
                  onSubmitMock={handleSubmit}
                  previewBlog={previewBlog}
                  previewBlogData={previewBlogData}
                  setPreviewBlog={setPreviewBlog}
                  setPreviewBlogData={setPreviewBlogData}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
